import { getContacts } from '@/api/contacts/getContacts.ts';
import { webapi } from '@/api/webapi.ts';

export const userApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    contacts: getContacts(builder),
  }),
});

export const { useContactsQuery } = userApi;
